import { render, staticRenderFns } from "./exchange-rate-card-results.vue?vue&type=template&id=095c44c6&scoped=true&lang=pug"
import script from "./exchange-rate-card-results.vue?vue&type=script&lang=js"
export * from "./exchange-rate-card-results.vue?vue&type=script&lang=js"
import style0 from "./exchange-rate-card-results.vue?vue&type=style&index=0&id=095c44c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c44c6",
  null
  
)

export default component.exports